module.exports = __webpack_public_path__ + "img/about-bg.d983970e.jpeg";